if (!customElements.get('custom-slider')) {
  class CustomSlider extends HTMLElement {
    constructor() {
      super();
      this.initializeProperties();
      this.setupPagination();
      this.setupButtons();
      this.setupIntersectionObserver();
    }

    // Initialize essential properties
    initializeProperties() {
      this.track = this.querySelector('.custom-slider__track');
      this.dots = this.querySelectorAll('.custom-slider__dot');
      this.buttons = this.querySelectorAll('button[data-switch-action]');
      this.slides = [...this.track.children];
      this.size = this.slides.length;
      this.currentIndex = 0;
    }

    // Attach click events to pagination dots
    setupPagination() {
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.scrollToIndex(index));
      });
    }

    // Attach click events to navigation buttons
    setupButtons() {
      this.buttons.forEach((button) =>
        button.addEventListener('click', () => this.handleButtonAction(button))
      );
    }

    // Observe slides to track the current visible index
    setupIntersectionObserver() {
      const observer = new IntersectionObserver(this.handleIntersection.bind(this), {
        threshold: 0.2,
      });

      this.slides.forEach((slide, index) => {
        slide.dataset.index = index; // Ensure index is accessible
        observer.observe(slide);
      });
    }

    // Scroll the track to a specific slide index
    scrollToIndex(index) {
      const slideWidth = this.slides[0].getBoundingClientRect().width;
      this.track.scrollLeft = slideWidth * index;
    }

    // Handle button click to scroll in the desired direction
    handleButtonAction(button) {
      const direction = button.getAttribute('data-switch-action');
      const slideWidth = this.slides[0].getBoundingClientRect().width;
      this.track.scrollLeft += direction === 'next' ? slideWidth : -slideWidth;
    }

    // Update the active dot and buttons when a slide becomes visible
    handleIntersection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.currentIndex = parseInt(entry.target.dataset.index, 10);
          this.updateActiveDot();
          this.updateNavigationButtons();
        }
      });
    }

    // Update active state for dots
    updateActiveDot() {
      this.dots.forEach((dot, index) =>
        dot.toggleAttribute('data-active', index === this.currentIndex)
      );
    }

    // Update active state for navigation buttons
    updateNavigationButtons() {
      const isAtStart = this.currentIndex === 0;
      const isAtEnd = this.currentIndex === this.size - 1;

      this.setButtonState(this.buttons[0], !isAtStart); // Previous button
      this.setButtonState(this.buttons[1], !isAtEnd);   // Next button
    }

    // Helper to set button active state
    setButtonState(button, isActive) {
      button.setAttribute('data-active', isActive ? 'true' : 'false');
    }
  }

  customElements.define('custom-slider', CustomSlider);
}
